import sortby from 'lodash/sortBy';
import { displayDate } from 'utils/date';

import { DailyStatsData } from '../types';
import { AdsRunData } from './types';

const MAX_ADS_RUN_DISPLAY_COUNT = 14;

export const formatAdsRunData = (data: DailyStatsData['data']): AdsRunData[] =>
  sortby(data, 'dateMillis', 'desc')
    .slice(data.length - MAX_ADS_RUN_DISPLAY_COUNT, data.length)
    .map(
      (stat) =>
        ({
          date: displayDate(stat.dateMillis, 'MMM DD'),
          unitLoaded: stat.unitLoad ? 1 : 0,
        } as AdsRunData),
    );
